import { trackEvent, TrackedEvent } from "@/domains/metrics";
import { clientEnvModule } from "@/modules/client-env";
import { logger } from "@/modules/logger";

const CLIENT_TELEMETRY_SOURCE = "client";
const CLIENT_REQUEST_PHASE = "client_request";
const UNKNOWN_AUTH_METHOD = "unknown";

function clientVersionFamily(clientVersion: string): "v1" | "v2" | "v3_plus" | "unknown" {
  const majorVersion = Number.parseInt(clientVersion.split(".", 1)[0] ?? "", 10);
  if (!Number.isFinite(majorVersion)) return "unknown";
  if (majorVersion === 1) return "v1";
  if (majorVersion === 2) return "v2";
  if (majorVersion >= 3) return "v3_plus";
  return "unknown";
}

function clientContext() {
  const clientVersion = clientEnvModule.packageVersion() ?? "unknown";

  return {
    client_surface: clientEnvModule.isDesktop() ? ("desktop" as const) : ("web" as const),
    client_version: clientVersion,
    client_version_family: clientVersionFamily(clientVersion),
  };
}

export function trackMcpConnectionSetupAttempt(): void {
  const { client_surface, client_version_family } = clientContext();

  trackEvent(TrackedEvent.McpConnectionSetupLifecycle, {
    telemetry_source: CLIENT_TELEMETRY_SOURCE,
    outcome: "attempted",
    phase: CLIENT_REQUEST_PHASE,
    error_kind: "none",
    error_class: "none",
    auth_method: UNKNOWN_AUTH_METHOD,
    client_surface,
    client_version_family,
  });
}

export function trackMcpConnectionSetupNetworkFailure(): void {
  const { client_surface, client_version, client_version_family } = clientContext();
  const properties = {
    telemetry_source: CLIENT_TELEMETRY_SOURCE,
    outcome: "failed",
    phase: CLIENT_REQUEST_PHASE,
    error_kind: "client_network_error",
    error_class: "client_network",
    auth_method: UNKNOWN_AUTH_METHOD,
    client_surface,
    client_version_family,
  } as const;

  trackEvent(TrackedEvent.McpConnectionSetupLifecycle, properties);
  void logger.warn({
    message: "mcp_connection_setup_client_network_failure",
    info: {
      ...properties,
      client_version,
    },
  });
}
